//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import photoCode from '@/components/code/index'
import { index, getRelationValidCode, registerRelation, loadRelationByUserName } from "@/assets/api/dataBase.js";
import {utils} from "@/assets/utils/utils.js";
import vPinyin from '@/assets/utils/vue-py.js';
import axios from 'axios'

import dbmap from "@/assets/dbs/hashmap.js"
import Alert from '@/components/alert/index'
export default {
    components:{
        photoCode,
        Alert
    },
    data () {
        return {

            isGender: false,


            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt:'waring',//负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg:'waring',
            sendInfo:{
                loanOrderCode:dbmap.get('loanOrderCode'),
                bankCode: dbmap.get('bankCode'),
                id:'',
                verifyCode:'', //验证码
                gender: '', //性别
                userNamePY: '', //姓名（拼音）
                userName:'', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName:'', // 名
                idCardNum:'', //身份证号码
                bankNum:'', // 银行卡
                mobile:'',//手机号
                identity: '', //关联人身份
                relationType: '', //与借款申请人关系
                spouseName: '',
            },
            //倒计时
            isSendPhone: false,
            isSendCode: true,//发送验证码按钮不可点击样式
            hint:'发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode:dbmap.get('productCode'),
                bankCode: dbmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo:{
                checked01: false,
                checked02: false,
                // checked03: false,
                checked07: false,
                checked08: false,
            },
            isCheckBox: false,
            isChecked: false,
            lastNEng: "",
            firstNEng: "",

             // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode:"",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode:false,
        }
    },
    mounted(){
        this.info();
        this.getImage();
    },
    methods: {
        info(){
            loadRelationByUserName(dbmap.get('sendInfo')).then(result => {
                if(result.responseCode === "000000"){
                    this.sendInfo.identity = result.responseData.identity
                    this.sendInfo.relationType = result.responseData.relationType
                    this.sendInfo.lastName = result.responseData.lastName
                    this.sendInfo.firstName = result.responseData.firstName
                    this.sendInfo.firstNameEng = result.responseData.firstNameEng
                    this.sendInfo.lastNameEng = result.responseData.lastNameEng
                    this.sendInfo.id = result.responseData.id
                    this.sendInfo.spouseName = result.responseData.spouseName
                }
            })
        },
        // 获取图形验证码
        getImage(){
           let url =  process.env.BASE_API2 +'image/signCaptcha'

            axios({
                method: 'post',
                url: url,
                data: {}
            }).then(result=>{
                console.log('result',result);
                this.imgSrc = result.data.responseData.verCode;
                this.uuId = result.data.responseData.uuId;
            })
        },
        verCodeChange(){
            if(this.verCode != ""){
                this.isVerCodeError = false
                this.getCursorCode  = false
            }else{
                this.isVerCodeError = true
                this.getCursorCode = true
                this.isBindPhotoError = false
                this.isAllSuccess()
            }
        },
        btnBack(){
            this.$router.push({
                path:"/index"
            });
            return false;
        },
        //验证码
        getPhotoCode(val){
           this.sendInfo.verifyCode = val
        },
        //姓名校验
        verNamePY(){
            this.isUserNamePY = true;
            if(!this.sendInfo.firstNameEng){
                this.isAllSuccess()
                return
            }
            this.isUserNamePY = false;
            this.isAllSuccess()
        },
        verlastNamePY(){
            this.isUserNamePY = true;
            if(!this.sendInfo.lastNameEng){
                this.isAllSuccess()
                return
            }
            this.isUserNamePY = false;
            this.isAllSuccess()
        },
        verlastName(){
            this.isUserName = true;
            if(!this.sendInfo.lastName){
                this.isAllSuccess()
                this.verlastNamePY()
                return
            }
            let PinYin = vPinyin.chineseToPinYin(this.sendInfo.lastName);
            if(this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng){
                this.sendInfo.lastNameEng = PinYin
            }
            this.isUserName = false;
            this.isAllSuccess()
            this.verlastNamePY()
            this.lastNEng = PinYin
        },
        verName(){
            this.isUserName = true;
            if(!this.sendInfo.firstName){
                this.isAllSuccess()
                this.verNamePY()
                return;
            }
            let PinYin = vPinyin.chineseToPinYin(this.sendInfo.firstName);
            if(this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng){
                this.sendInfo.firstNameEng = PinYin
            }
            this.isUserName = false;
            this.isAllSuccess()
            this.verNamePY()
            this.firstNEng = PinYin
        },
        // 身份证校验
        verificationIdCoder(){
            let sex = null
            this.isCardId = true;
            const city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
            if(this.sendInfo.idCardNum.length === 0){
                this.cardIdTxt = "身份证号不能为空！"
                this.sendInfo.gender = ''
                this.isAllSuccess()
                return;
            }else if(this.sendInfo.idCardNum.length && this.sendInfo.idCardNum.length < 18){
                this.cardIdTxt = "身份证号长度不够！"
                this.sendInfo.gender = ''
                this.isAllSuccess()
                return;
            }else if(!this.sendInfo.idCardNum || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.sendInfo.idCardNum)){
                this.cardIdTxt = "身份证号格式有误！"
                this.sendInfo.gender = ''
                this.isAllSuccess()
                return;
            }else if(!city[this.sendInfo.idCardNum.substr(0,2)]){
                this.cardIdTxt = "地址编码有误！"
                this.sendInfo.gender = ''
                this.isAllSuccess()
                return;
            }
            else{
                //18位身份证需要验证最后一位校验位
                if(this.sendInfo.idCardNum.length === 18){
                    let Code = this.sendInfo.idCardNum.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                    //校验位
                    var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                        for (var i = 0; i < 17; i++)
                    {
                        ai = Code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];
                    if(parity[sum % 11] != Code[17]){
                        this.cardIdTxt = "身份证号不正确！"
                        this.sendInfo.gender = ''
                        this.isAllSuccess()
                        return;
                    }
                    sex = this.sendInfo.idCardNum.substring(16,17)
                }else{
                    sex = this.sendInfo.idCardNum.substring(13,14)
                }
            }
            if( sex%2 === 0){
                this.sendInfo.gender = '02'
            }else{
                this.sendInfo.gender = '01'
            }
            this.isCardId = false;
            this.cardIdTxt = "waring";
            this.isAllSuccess()
        },
        //银行卡校验
        verBankCard(e){
            if(e.target){
                this.sendInfo.bankNum = e.target.value
            }
            this.isBankCard = true;
            if(this.sendInfo.bankNum === ''){
                this.bankCardTxt = '银行卡号不能为空！'
                this.isAllSuccess()
                return;
            }else if(this.sendInfo.bankNum && this.sendInfo.bankNum.length < 13){
                this.bankCardTxt = '银行卡位数有误！'
                this.isAllSuccess()
                return;
            }
            this.isBankCard = false;
            this.bankCardTxt = 'waring';
            this.isAllSuccess()
        },
        // 验证手机号码
        verMobilePhone(e){
            if(e.target){
                this.sendInfo.mobile = e.target.value
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            let reg=11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if(this.sendInfo.mobile==''){
                this.bindPhotoTxt = '手机号码不能为空！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }else if(this.sendInfo.mobile && this.sendInfo.mobile.length < 11){
                this.bindPhotoTxt = '手机号码位数不够！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }else if(!reg.test(this.sendInfo.mobile)){
                this.bindPhotoTxt = '手机号码格式有误！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess()
        },
        //获取验证码
        getVerifyCode() {
            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode =  this.verCode;
            this.valiCodeParams.uuId =  this.uuId;
            getRelationValidCode(this.valiCodeParams).then(result => {
                if(result.responseCode === "000000"){

                    this.isDisabled = false;
                    
                    //开始倒计时
                    this.countdownTime();
                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                }else if (result.responseCode == "000405") {
                    this.isVerCodeError = true;
                    this.isAllSuccess();
                    this.verCodeErrorText = result.responseMessage;
                }
            })
        },
        // 倒计时 方法
        countdownTime() {
            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.imageValidCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(() => {
                    if (
                        this.countdown.count > 0 &&
                        this.countdown.count <= this.countdown.TIME_COUNT
                    ) {
                        this.countdown.counts = '重发验证码（'+this.countdown.count + "s）";
                        this.countdown.count--;
                    } else {
                        clearInterval(this.countdown.timer);
                        this.imageValidCode = false;
                        this.getCursorCode = false;
                        this.countdown.timer = null;
                        this.countdown.counts = this.hint;
                        this.isSendPhone = false;
                        this.isSendCode = false;
                    }
                }, 1000);
            }
        },
        //验证码校验
        verPhotoCode(){
            if(this.sendInfo.verifyCode.length !== 6){
                this.photoCodeBool = true
                this.isBindPhotoError = true
                this.toastMsg = '验证码位数不够！'
                this.isAllSuccess()
                return false
            }else{
                this.photoCodeBool = false
                this.isBindPhotoError = false
                this.toastMsg = 'waring'
                this.isAllSuccess()
            }
        },

        //四要素认证
        callFourEleCheck(){
            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC'
            this.sendInfo.appName = "00PACIFIC"

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            let capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            let ret = "";
            for (var i = 0; i < capital.length; i++) {
                let c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret
            // 授权协议
            this.sendInfo.cup1002 = this.verNoticeInfo.checked01
            this.sendInfo.type1004 = this.verNoticeInfo.checked02,

            this.sendInfo.type1007 = this.verNoticeInfo.checked07,
            this.sendInfo.type1008 = this.verNoticeInfo.checked08,

            dbmap.set('sendInfo',this.sendInfo)
            registerRelation(this.sendInfo).then(result => {
                this.isBindPhotoError = false
                this.isAllRrquridSuccess = false
                if (result.responseCode === "000000") {

                    let fbCode = result.responseData.fbCode
                    let fbMessage = result.responseData.fbMessage
                    let loginName = result.responseData.loginName || ''
                    let retryBtn = result.responseData.retryBtn || ''
                    let messageInfo = utils.routerJump.returnUrl(fbCode);
                    let url = messageInfo.url
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    this.$router.push({
                        path:url,
                        query:{
                            code:fbCode,
                            fbMessage:fbMessage,//认证失败还有所少次变化 后端返回
                            retryBtn:retryBtn,// '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName:loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    })
                }else if(result.responseCode === "000405"){
                    this.isBindPhotoError = true;
                    this.toastMsg = result.responseMessage;
                    this.isAllRrquridSuccess = true

                    window.scrollTo(0, 0);
                }
            });
        },
        // 下一步
        pass(){
            this.isAllRrquridSuccess = false
            this.verlastName()
            this.verName()
            this.verlastNamePY()
            this.verNamePY()
            this.verificationIdCoder()
            this.verBankCard(1)
            this.verMobilePhone(1)
            this.verPhotoCode()

            // this.verNotice()
            this.verNoticeBox()
            this.genderChange()

            let statusInfo = this.isAllSuccess()
            if(!statusInfo){
                this.callFourEleCheck()
            }else{
                window.scrollTo(0, 0);
            }
        },
        genderChange(){
             if( !this.sendInfo.gender){
                this.isGender = true;
                this.isAllSuccess()
            }else{
                this.isGender = false;
                this.isAllSuccess()
            }
        },
        isAllSuccess(){
            if( !this.isCheckBox && !this.isChecked && !this.isTaxCode  && !this.isCardId && !this.isUserName && !this.isUserNamePY
                && !this.isBankCard && !this.isBindPhoto && !this.isBindPhotoError && !this.isGender && !this.isVerCodeError){
                this.isAllRrquridSuccess = false
                return false
            }else{
                this.isAllRrquridSuccess = true
                return true
            }
        },
        keyEvent(e){
            if([37,38,39,40].indexOf(e.keyCode) > -1){
                let a
                if(e.currentTarget.previousElementSibling.value == '01'){
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0]
                }else{
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0]
                }
                    a.focus()
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            }else{
                return 
            }
        },
        spaceEvent(e){
            e.currentTarget.previousElementSibling.focus()
            let aa = e.currentTarget.previousElementSibling.name
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value
        },
        // 授权
        spaceEventCheckBox(e){
            e.currentTarget.previousElementSibling.focus()
            let aa = e.currentTarget.previousElementSibling.name
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa]
        },
        //认证须知校验
        verNotice(){
            if( this.verNoticeInfo.checked02 === false){
                this.isChecked = true;
                this.isAllSuccess()
            }else{
                this.isChecked = false;
                this.isAllSuccess()
            }
        },
        verNoticeBox(){
            if(this.verNoticeInfo.checked07 === false || this.verNoticeInfo.checked08 === false){
                this.isCheckBox = true;
                this.isAllSuccess()
            }else{
                this.isCheckBox = false;
                this.isAllSuccess()
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/view/peopleVerification.vue